// extracted by mini-css-extract-plugin
export default {"platform":"MainLayout_platform__Dz9S8","renderedView":"MainLayout_renderedView__-xUIJ"};